
export const LR_TEMPLATE_HTML = `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<title>Lorry Receipt - {{grNo}}</title>
<style>
  * { box-sizing: border-box; }
  body {
    font-family: 'Segoe UI', Arial, sans-serif;
    background: #fff;
    margin: 0;
    padding: 16px;
  }
  .lr-sheet {
    max-width: 850px;
    margin: 0 auto 24px;
    background: #fff;
    border: 2px solid #000;
    font-size: 13px;
    color: #111;
  }
  .lr-header {
    display: flex;
    align-items: stretch;
    border-bottom: 2px solid #000;
  }
  .lr-logo {
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 2px solid #000;
    font-weight: 800;
    font-size: 20px;
    letter-spacing: 3px;
  }
  .lr-title-block { flex: 1; text-align: center; padding: 6px 4px; }
  .lr-jurisdiction { font-size: 11px; font-style: italic; }
  .lr-company-name { font-size: 22px; font-weight: 800; letter-spacing: 0.5px; margin: 2px 0; }
  .lr-copy-type {
    width: 130px; display: flex; align-items: center; justify-content: center;
    border-left: 2px solid #000; font-size: 12px; font-weight: 600; text-align: center; padding: 4px;
  }
  .lr-office-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 4px 10px; border-bottom: 2px solid #000; font-size: 11.5px;
  }
  .lr-info-grid { display: flex; border-bottom: 2px solid #000; }
  .lr-info-left { flex: 2.1; border-right: 2px solid #000; }
  .lr-info-right { flex: 1; }
  .lr-field-row {
    display: flex; border-bottom: 1px solid #ccc; padding: 5px 8px; align-items: baseline; gap: 6px;
  }
  .lr-field-row:last-child { border-bottom: none; }
  .lr-label { font-weight: 600; white-space: nowrap; font-size: 12px; }
  .lr-value { flex: 1; border-bottom: 1px dotted #444; min-height: 16px; font-weight: 500; }
  .lr-two-col { display: flex; gap: 14px; flex: 1; }
  .lr-two-col .lr-field-row { flex: 1; }

  table.lr-table { width: 100%; border-collapse: collapse; font-size: 12px; }
  table.lr-table th, table.lr-table td {
    border: 1.5px solid #000; padding: 6px 8px; vertical-align: top;
  }
  table.lr-table th { background: #f4f4f4; font-weight: 700; text-align: center; }
  .lr-cell-blank { height: 150px; }
  .weight-sub-th { text-align: center; font-weight: 700; }

  /* Freight / Signatory row baked into the table, under Pkgs / Seal No columns.
     Extra height + bottom-aligned single-line label leaves blank space above
     for an actual pen signature. */
  .lr-table-footer-row td { height: 74px; vertical-align: bottom; padding-bottom: 10px; }
  .lr-empty-td { border-right: none; border-left: none; }
  .lr-freight-cell { font-weight: 600; text-align: left; white-space: nowrap; }
  .lr-signatory-cell { font-weight: 600; text-align: center; white-space: nowrap; }

  .lr-bottom-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 8px 10px 10px; font-size: 11.5px;
  }
  .lr-gst-note { font-weight: 600; }
  .lr-terms-ref { font-size: 10.5px; font-style: italic; }

  /* ===== Back page: Waybill Terms and Conditions ===== */
  .terms-page {
    padding: 28px 32px;
  }
  .terms-heading {
    text-align: center;
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 1px;
    margin-bottom: 18px;
    text-transform: uppercase;
  }
  .terms-body {
    font-size: 10.5px;
    line-height: 1.5;
    column-count: 1;
    white-space: pre-wrap;
  }
  .terms-placeholder-note {
    background: #fff8e1;
    border: 1px dashed #d4a017;
    padding: 10px 14px;
    font-size: 11px;
    margin-bottom: 16px;
    color: #7a5c00;
  }

  @media print {
    body { padding: 0; }
    .lr-sheet { border: 2px solid #000; margin-bottom: 0; }
    .terms-page { page-break-before: always; }
    .terms-placeholder-note { display: none; }
  }
</style>
</head>
<body>

  <!-- ============ FRONT: Lorry Receipt ============ -->
  <div class="lr-sheet">

    <div class="lr-header">
      <div class="lr-logo">A|S|C</div>
      <div class="lr-title-block">
        <div class="lr-jurisdiction">Subject to Gurgaon Jurisdiction</div>
        <div class="lr-company-name">APOLLO Supply Chain Pvt. Ltd.</div>
      </div>
      <div class="lr-copy-type">Consignor Copy</div>
    </div>

    <div class="lr-office-row">
      <span>Corporate Office: Apollo Towers, Plot No. 20, Sector-44, Gurugram, Haryana-122002</span>
      <span>GSTIN : 06AALCA0748D1ZY</span>
    </div>

    <div class="lr-info-grid">
      <div class="lr-info-left">
        <div class="lr-field-row">
          <span class="lr-label">Consignor</span>
          <span class="lr-value">{{consignorName}}</span>
        </div>
        <div class="lr-two-col">
          <div class="lr-field-row">
            <span class="lr-label">Pincode No.</span>
            <span class="lr-value">{{consignorPincode}}</span>
          </div>
        </div>
        <div class="lr-two-col">
          <div class="lr-field-row">
            <span class="lr-label">GST No.</span>
            <span class="lr-value">{{consignorGst}}</span>
          </div>
          <div class="lr-field-row">
            <span class="lr-label">Phone No.</span>
            <span class="lr-value">{{consignorPhone}}</span>
          </div>
        </div>
        <div class="lr-field-row">
          <span class="lr-label">Consignee</span>
          <span class="lr-value">{{consigneeName}}</span>
        </div>
        <div class="lr-two-col">
          <div class="lr-field-row">
            <span class="lr-label">Pincode No.</span>
            <span class="lr-value">{{consigneePincode}}</span>
          </div>
        </div>
        <div class="lr-two-col">
          <div class="lr-field-row">
            <span class="lr-label">GST No.</span>
            <span class="lr-value">{{consigneeGst}}</span>
          </div>
          <div class="lr-field-row">
            <span class="lr-label">Phone No.</span>
            <span class="lr-value">{{consigneePhone}}</span>
          </div>
        </div>
      </div>

      <div class="lr-info-right">
        <div class="lr-field-row">
          <span class="lr-label">G R No.<br/>(Non-negotiable)</span>
          <span class="lr-value">{{grNo}}</span>
        </div>
        <div class="lr-field-row">
          <span class="lr-label">Date</span>
          <span class="lr-value">{{lrDate}}</span>
        </div>
        <div class="lr-field-row">
          <span class="lr-label">From</span>
          <span class="lr-value">{{from}}</span>
        </div>
        <div class="lr-field-row">
          <span class="lr-label">To</span>
          <span class="lr-value">{{to}}</span>
        </div>
        <div class="lr-field-row">
          <span class="lr-label">Lorry No.</span>
          <span class="lr-value">{{lorryNo}}</span>
        </div>
      </div>
    </div>

    <table class="lr-table">
      <thead>
        <tr>
          <th style="width: 18%;">Invoice/STN No.<br/>&amp; E-Way Bill No.</th>
          <th style="width: 20%;">Container No./Loose Cargo<br/>Said to Contain</th>
          <th style="width: 12%;">Value of<br/>Goods</th>
          <th colspan="2" style="width: 20%;">Weight</th>
          <th style="width: 12%;">No of<br/>Pkg(s)</th>
          <th style="width: 18%;">Seal No./OTL No.</th>
        </tr>
        <tr>
          <th></th><th></th><th></th>
          <th class="weight-sub-th">Actual</th>
          <th class="weight-sub-th">Charged</th>
          <th></th><th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="lr-cell-blank">{{invoiceEwayValidLabel}}</td>
          <td class="lr-cell-blank">{{containerCargo}}</td>
          <td class="lr-cell-blank">{{valueOfGoods}}</td>
          <td class="lr-cell-blank">{{weightActual}}</td>
          <td class="lr-cell-blank">{{vehicleType}}</td>
          <td class="lr-cell-blank">{{noOfPkgs}}</td>
          <td class="lr-cell-blank">{{sealNo}}</td>
        </tr>
        <tr class="lr-table-footer-row">
          <td colspan="5" class="lr-empty-td"></td>
          <td class="lr-freight-cell">Freight To Be Billed</td>
          <td class="lr-signatory-cell">Authorised Signatory</td>
        </tr>
      </tbody>
    </table>

    <div class="lr-bottom-row">
      <span class="lr-gst-note">GST TO BE PAID BY CONSIGNOR OR CONSIGNEE</span>
      <span class="lr-terms-ref">Terms and Condition overleaf</span>
    </div>

  </div>


</body>
</html>
`;

// ⚠️ Placeholder only — the scanned "Waybill Terms and Conditions" photo
// wasn't legible enough to transcribe accurately (blurry + mirrored watermark).
// Replace this with the verified legal text before this goes to print/production.
// export const WAYBILL_TERMS_TEXT = `[Paste the verified Waybill Terms and Conditions text here.]`;

export interface LrTemplateData {
  consignorName: string;
  consignorPincode: string;
  consignorGst: string;
  consignorPhone: string;
  consigneeName: string;
  consigneePincode: string;
  consigneeGst: string;
  consigneePhone: string;
  grNo: string;
  lrDate: string;
  from: string;
  to: string;
  lorryNo: string;
  invoiceEwayValidLabel: string;
  containerCargo: string;
  valueOfGoods: string;
  weightActual: string;
  vehicleType: string;
  noOfPkgs: string;
  sealNo: string;
//   termsAndConditionsText: string;
}

/**
 * Maps live trip data -> printed LR fields.
 *
 *   Consignor        -> Customer (order)
 *   Consignee         -> Receiver
 *   G R No.           -> LR No. (LR section, auto or manual)
 *   Date              -> Dispatch Date (LR date)
 *   From / To         -> Origin / Destination (order.source / order.destination)
 *   Lorry No.         -> Vehicle No. (LHC vehicleNumber)
 *   Invoice/STN No.   -> Invoice No. + E-Way Bill No. + Valid Upto (combined, 3 lines)
 *   Value of Goods    -> E-Way Bill invoice amount (cum GST)
 *   Container/Cargo   -> Loading Info material description
 *   Weight Actual     -> Loading Info weight
 *   Weight Charged    -> Vehicle Type (order.vehicleTypeLabel / passed in explicitly)
 *   No of Pkg(s)      -> Loading Info numberOfPackages
 *   Seal No.          -> Loading Info sealNumber
 *
 * Any field left empty simply renders as "--" — nothing is force-filled
 * with placeholder/dummy text.
 */
export function buildLrTemplateData(
  order: any,
  lrRow: any,
  lhcRow: any,
  loadingForm: any,
  ewayBill: any,
  vehicleTypeLabel?: string
): LrTemplateData {
  return {
    consignorName: order?.customerName || '--',
    consignorPincode: order?.customerPincode || '--',
    consignorGst: order?.customerGst || '--',
    consignorPhone: order?.customerPhone || '--',

    consigneeName: order?.receiverName || '--',
    consigneePincode: order?.receiverPincode || '--',
    consigneeGst: order?.receiverGst || '--',
    consigneePhone: order?.receiverPhone || '--',

    grNo: lrRow?.lrNumber || '--',
    lrDate: formatDate(lrRow?.lrDate),
    from: order?.source || '--',
    to: order?.destination || '--',
    lorryNo: lhcRow?.vehicleNumber || '--',

    invoiceEwayValidLabel: buildInvoiceEwayValidLabel(ewayBill),
    containerCargo: loadingForm?.materialTypeDescription || '--',
    valueOfGoods: ewayBill?.invoiceValue ? formatCurrency(ewayBill.invoiceValue) : '--',
    weightActual: loadingForm?.weight ? `${loadingForm.weight} T` : '--',
    vehicleType: vehicleTypeLabel || order?.vehicleTypeLabel || '--',
    noOfPkgs: loadingForm?.numberOfPackages ?? '--',
    sealNo: loadingForm?.sealNumber || '--',

    // termsAndConditionsText: WAYBILL_TERMS_TEXT,
  };
}

function buildInvoiceEwayValidLabel(ewayBill: any): string {
  const invoiceNo = ewayBill?.invoiceNo || '--';
  const ewbNo = ewayBill?.ewayBillNumber || '--';
  const validUpto = ewayBill?.validUptoObj ? formatDate(ewayBill.validUptoObj) : '--';
  return `Inv: ${invoiceNo}<br/>EWB: ${ewbNo}<br/>Valid: ${validUpto}`;
}

export function renderLrHtml(data: LrTemplateData): string {
  let html = LR_TEMPLATE_HTML;
  Object.keys(data).forEach((key) => {
    const token = new RegExp(`{{${key}}}`, 'g');
    html = html.replace(token, String((data as any)[key] ?? '--'));
  });
  return html;
}

export function printLrHtml(filledHtml: string): void {
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;
  printWindow.document.open();
  printWindow.document.write(filledHtml);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
  };
}

export function downloadLrHtml(filledHtml: string, fileName: string): void {
  const blob = new Blob([filledHtml], { type: 'text/html' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
}

function formatDate(value: any): string {
  if (!value) return '--';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '--';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function formatCurrency(value: number): string {
  if (value == null) return '--';
  return `₹${Number(value).toLocaleString('en-IN')}`;
}